import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { currency, noCurrency } from 'helpers/utils';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';
import { indications } from './data';
//import { v4 as uuid } from 'uuid';

const FormFnc = ({ watch, setData, financing, setFinancing, onClose }) => {
 const {
  reset,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm();

 useEffect(() => {
  if (financing)
   Object.entries(financing).map(e => {
    const isCurrency = document.querySelector(`#financing [name="${e[0]}"]`)?.alt == 'currency';
    setValue(e[0], isCurrency ? currency(e[1], true) : e[1]);
   });
 }, [financing]);

 const onSubmitData = newD => {
  const { plus, ...newData } = newD;

  Object.entries(newData).map(fnc => {
   newData[fnc[0]] = /%|\$/.test(fnc[1]) ? noCurrency(fnc[1]) : fnc[1];
  });

  setData('financings', [...watch('financings').filter(e => e.name !== newData?.name && e.name !== financing?.name), newData]);

  if (financing || !plus) {
   onClose();
   setFinancing(null);
  }

  return reset({
   name: null,
   minInitialPay: null,
   initialFee: null,
   maxInitials: null,
   minFeeIni: null,
   maxFinancing: null,
   minFeeFnc: null,
   lateFee: null,
   rate: null,
   amortize: null,
   note: null
  });
 };

 const handleFieldChange = ({ target: { name, value } }) => setValue(name, currency(value, true));

 const onError = err => {
  console.log('se genero un error en el formulario', err);
 };

 return (
  <div id="financing">
   <Row className="mb-3 g-3">
    <Input
     type="text"
     name="name"
     label="Nombre"
     errors={errors}
     placeholder="Financiamiento"
     help={indications.find(e => e.name === 'name')}
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('name', {
       required: 'Campo requerido',
       validate: value => {
        const uno = !/[^a-z0-9_-]/g.test(value) || 'Caracteres invalidos';
        const dos = !watch('financings')?.some(e => e.name === value && value !== financing?.name) || 'Nombre ya existe';
        return typeof uno === 'boolean' ? dos : uno;
       },
       minLength: {
        value: 5,
        message: 'Pocos caracteres'
       }
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      maxLength: 20,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     errors={errors}
     label="Separacion"
     name="minInitialPay"
     placeholder="Monto de separacion"
     help={indications.find(e => e.name === 'minInitialPay')}
     formGroupProps={{ as: Col, sm: 6 }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('minInitialPay', {
       required: 'Campo requerido',
       validate: value => /\$|^0/.test(value) || 'Valor invalido'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      alt: 'currency',
      size: 'sm',
      onChange: handleFieldChange
     }}
    />
   </Row>

   <Row className="mb-3 g-3">
    <Input
     type="text"
     errors={errors}
     label="Inicial"
     name="initialFee"
     placeholder="0.0%"
     help={indications.find(e => e.name === 'initialFee')}
     formGroupProps={{ as: Col, sm: { span: 3, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('initialFee', {
       required: 'valor requerido',
       validate: value => parseFloat(value) < 1 || 'Debe ser < 1'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      alt: 'currency',
      size: 'sm',
      onChange: handleFieldChange
     }}
    />

    <Input
     type="text"
     errors={errors}
     name="maxInitials"
     label="Diferir en"
     placeholder="Meses"
     help={indications.find(e => e.name === 'maxInitials')}
     formGroupProps={{ as: Col, sm: 3 }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('maxInitials', {
       required: 'valor requerido',
       validate: value => !isNaN(value) || 'Deve ser num'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="minFeeIni"
     errors={errors}
     label="Cuota min."
     placeholder="Monto minimo"
     help={indications.find(e => e.name === 'minFee')}
     formGroupProps={{ as: Col, sm: 6 }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('minFeeIni', {
       required: 'Campo requerido',
       validate: value => /\$|^0/.test(value) || 'Valor invalido'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      alt: 'currency',
      size: 'sm',
      onChange: handleFieldChange
     }}
    />
   </Row>

   <Row className="mb-3 g-3">
    <Input
     type="text"
     errors={errors}
     name="maxFinancing"
     placeholder="Meses"
     label="Financiar en"
     help={indications.find(e => e.name === 'maxFinancing')}
     formGroupProps={{ as: Col, sm: { span: 4, offset: 2 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('maxFinancing', {
       required: 'valor requerido',
       validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'Debe ser > 0'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="minFeeFnc"
     errors={errors}
     label="Cuota min."
     placeholder="Monto minimo"
     help={indications.find(e => e.name === 'maxFinancing')}
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('minFeeFnc', {
       required: 'valor requerido',
       validate: value => /\$|^0/.test(value) || 'Valor invalido'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      alt: 'currency',
      size: 'sm',
      onChange: handleFieldChange
     }}
    />
   </Row>

   <Row className="mb-3 g-3">
    <Input
     type="text"
     label="Mora"
     name="lateFee"
     errors={errors}
     placeholder="Meses"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('lateFee', {
       setValueAs: v => (!isNaN(v) && !!v ? v : 0)
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="rate"
     label="Tasa"
     errors={errors}
     placeholder="0%"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('rate', {
       setValueAs: v => (!isNaN(v) && !!v ? v : 0)
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      alt: 'currency',
      size: 'sm',
      onChange: handleFieldChange
     }}
    />

    <Input
     type="text"
     name="amortize"
     errors={errors}
     label="Amortizar"
     placeholder="Meses"
     help={indications.find(e => e.name === 'lateFee')}
     formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('amortize', {
       setValueAs: v => (!isNaN(v) && !!v ? v : 0)
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />
   </Row>

   <Input
    type="textarea"
    errors={errors}
    label="Nota"
    name="note"
    placeholder="Campo para nota (opcional)"
    help={indications.find(e => e.name === 'note')}
    formGroupProps={{ className: 'mb-3' }}
    formLabelProps={{ className: 'text-lg-end mb-1' }}
    formControlProps={{
     ...register('note', {
      setValueAs: v => (v ? v : null)
     }),
     autoComplete: 'off',
     disabled: false,
     size: 'sm',
     rows: 2
    }}
   />

   {!financing && (
    <Form.Check
     type="switch"
     id="custom-switch"
     label="Seguir agregando financiamientos?"
     className="form-label-nogutter py-3"
     name="plus"
     {...register('plus')}
    />
   )}

   <IconButton
    size="sm"
    icon={financing ? 'redo-alt' : 'plus'}
    transform="shrink-3"
    className="float-end"
    variant="falcon-default"
    onClick={() => handleSubmit(onSubmitData, onError)()}
   >
    {financing ? 'Actualizar' : 'Agregar'}
   </IconButton>

   <IconButton type="reset" size="sm" icon="ban" transform="shrink-3" variant="falcon-default" onClick={() => setFinancing(null)}>
    Cancelar
   </IconButton>
  </div>
 );
};

FormFnc.propTypes = {
 watch: PropTypes.func,
 setData: PropTypes.func, //.isRequired,
 setFinancing: PropTypes.func, //.isRequired,
 financing: PropTypes.object,
 onClose: PropTypes.func
};

FormFnc.defaultProps = { financings: [] };

export default FormFnc;
